(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(45583);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EntityLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _hooks_use_channel_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87117);
/* harmony import */ var _hooks_use_default_entity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86609);
/* harmony import */ var _kenai_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59811);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);







function EntityLogo(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var logo = (0,_hooks_use_channel_config__WEBPACK_IMPORTED_MODULE_1__/* .useChannelConfig */ .M)().logo;
    var defaultEntity = (0,_hooks_use_default_entity__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultEntity */ .t)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_kenai_core__WEBPACK_IMPORTED_MODULE_5__/* .S3Image */ .P, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        src: logo,
        width: 150,
        height: 150,
        alt: (defaultEntity === null || defaultEntity === void 0 ? void 0 : defaultEntity.companyName) || "",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("object-contain", className)
    }, props));
}


/***/ }),

/***/ 64045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StepperLayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/hooks/use-authentication.ts
var use_authentication = __webpack_require__(75961);
// EXTERNAL MODULE: ./src/hooks/use-induction.ts
var use_induction = __webpack_require__(7722);
// EXTERNAL MODULE: ./src/hooks/use-step.ts
var use_step = __webpack_require__(43216);
// EXTERNAL MODULE: ./src/hooks/use-text-overrides.ts
var use_text_overrides = __webpack_require__(84055);
// EXTERNAL MODULE: ./src/slices/stepper.ts
var stepper = __webpack_require__(76739);
// EXTERNAL MODULE: ./src/store/index.ts + 5 modules
var store = __webpack_require__(13793);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(67107);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98485);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stepper/Stepper.js + 3 modules
var Stepper = __webpack_require__(81025);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Step/Step.js + 1 modules
var Step = __webpack_require__(84419);
// EXTERNAL MODULE: ../../node_modules/@mui/material/StepLabel/StepLabel.js + 5 modules
var StepLabel = __webpack_require__(83375);
// EXTERNAL MODULE: ../../node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(73303);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/toolbar-stepper/toolbar-stepper.tsx







var Helper = /*#__PURE__*/ function() {
    "use strict";
    function Helper() {
        (0,_class_call_check/* default */.Z)(this, Helper);
    }
    Helper.getFunctionalProp = function getFunctionalProp(label, prop) {
        if (typeof prop === "function") {
            return prop(label);
        }
        return prop;
    };
    Helper.getLabelFromLabelMapper = function getLabelFromLabelMapper(label, labelMapper) {
        var ref;
        return (ref = labelMapper === null || labelMapper === void 0 ? void 0 : labelMapper[label]) !== null && ref !== void 0 ? ref : label;
    };
    Helper.getNextIndex = function getNextIndex(activeStep, steps) {
        var disabledSteps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        var isLastStep = activeStep === steps.length - 1;
        var nextStepIndex = isLastStep ? 0 : activeStep + 1;
        var stepName = steps[nextStepIndex];
        var isDisabled = disabledSteps.includes(stepName);
        if (isDisabled) {
            return activeStep;
        }
        return nextStepIndex;
    };
    Helper.getStepProgress = function getStepProgress(activeStep, stepsTotal) {
        return Math.min(100, Math.round(activeStep / stepsTotal * 100)) + 25;
    };
    return Helper;
}();
function MobileStepper(props) {
    var ref;
    var stepsTotal = props.steps.length;
    var stepProgress = (0,react.useMemo)(function() {
        return Helper.getStepProgress(props.activeStep, stepsTotal);
    }, [
        props.activeStep,
        stepsTotal
    ]);
    var labels = (0,react.useMemo)(function() {
        return {
            activeStepLabel: Helper.getLabelFromLabelMapper(props.steps[props.activeStep], props.labelMapper),
            nextStepLabel: Helper.getLabelFromLabelMapper(props.steps[props.activeStep + 1], props.labelMapper),
            counter: "".concat(props.activeStep + 1, " of ").concat(stepsTotal)
        };
    }, [
        props.activeStep,
        props.labelMapper,
        props.steps,
        stepsTotal
    ]);
    var ref1;
    var disabled = (ref1 = (ref = props.disabledSteps) === null || ref === void 0 ? void 0 : ref.includes(props.steps[props.activeStep + 1])) !== null && ref1 !== void 0 ? ref1 : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("flex space-x-4 -mr-2", "justify-end"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile-stepper-labels flex flex-col justify-center items-end align-middle",
                onClick: function() {
                    if ("onChangeStep" in props && !disabled) {
                        var nextStepIndex = Helper.getNextIndex(props.activeStep, props.steps, props.disabledSteps);
                        props.onChangeStep(nextStepIndex, props.steps[nextStepIndex]);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h5",
                        color: "text.primary",
                        children: labels.activeStepLabel
                    }),
                    labels.nextStepLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "text.secondary",
                        children: [
                            "Next: ",
                            labels.nextStepLabel
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative inline-flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, (0,_object_spread/* default */.Z)({
                        variant: "determinate",
                        thickness: 3,
                        size: 60,
                        value: stepProgress
                    }, props.progressProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center top-0 right-0 bottom-0 left-0 absolute",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            component: "span",
                            color: "primary",
                            children: labels.counter
                        })
                    })
                ]
            })
        ]
    });
}
var DesktopStepper = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stepper/* default */.Z, {
        activeStep: props.activeStep,
        children: props.steps.map(function(label, stepIndex) {
            var ref, ref1;
            var ref2;
            var disabled = (ref2 = (ref = props.disabledSteps) === null || ref === void 0 ? void 0 : ref.includes(label)) !== null && ref2 !== void 0 ? ref2 : false;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Helper.getFunctionalProp(label, props.stepProps)), {
                disabled: disabled,
                onClick: function() {
                    if ("onChangeStep" in props && !disabled) {
                        props.onChangeStep(stepIndex, props.steps[stepIndex]);
                    }
                },
                completed: (ref1 = props.skippedSteps) === null || ref1 === void 0 ? void 0 : ref1.includes(label),
                className: classnames_default()(!disabled && "cursor-pointer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabel/* default */.Z, {
                    children: Helper.getLabelFromLabelMapper(label, props.labelMapper)
                })
            }), label);
        })
    });
};
var ToolbarStepper = function(props) {
    var mobileDevice = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    if (mobileDevice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileStepper, {
            steps: props.steps,
            activeStep: props.activeStep,
            labelMapper: props.labelMapper,
            onChangeStep: props.onChangeStep,
            disabledSteps: props.disabledSteps
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopStepper, {
        steps: props.steps,
        activeStep: props.activeStep,
        labelMapper: props.labelMapper,
        onChangeStep: props.onChangeStep,
        disabledSteps: props.disabledSteps
    });
};

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/components/EntityLogo.tsx
var EntityLogo = __webpack_require__(36913);
;// CONCATENATED MODULE: ./src/components/StepperLayout.tsx















var useLabelMapper = function() {
    var textOverrides = (0,use_text_overrides/* useTextOverrides */.u)();
    var _agreementStepLabel, _authenticationStepLabel, _inductionStepLabel, _summaryStepLabel;
    return {
        agreement: (_agreementStepLabel = textOverrides.agreementStepLabel) !== null && _agreementStepLabel !== void 0 ? _agreementStepLabel : "Agreement",
        authentication: (_authenticationStepLabel = textOverrides.authenticationStepLabel) !== null && _authenticationStepLabel !== void 0 ? _authenticationStepLabel : "Authentication",
        induction: (_inductionStepLabel = textOverrides.inductionStepLabel) !== null && _inductionStepLabel !== void 0 ? _inductionStepLabel : "Induction",
        summary: (_summaryStepLabel = textOverrides.summaryStepLabel) !== null && _summaryStepLabel !== void 0 ? _summaryStepLabel : "Summary"
    };
};
var StepperLayout = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,use_step/* useStepper */.t)(), currentStep = ref.currentStep, steps = ref.steps;
    var dispatch = (0,store/* useDispatch */.I0)();
    var loading = (0,use_induction/* useInduction */.O)().loading;
    var processingToken = (0,use_authentication/* useAuthentication */.J)().processingToken;
    var router = (0,next_router.useRouter)();
    var disableAllSteps = currentStep === "summary";
    var disabledSteps = disableAllSteps ? steps : [];
    if (!disableAllSteps) {
        var inductionDisabled = !processingToken;
        var summaryDisabled = ![
            "success",
            "failure"
        ].includes(loading);
        if (inductionDisabled) {
            disabledSteps.push("induction");
        }
        if (summaryDisabled) {
            disabledSteps.push("summary");
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[80px] flex items-center justify-center py-4 space-x-6 px-6 bg-slate-50 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: router.asPath,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityLogo/* default */.Z, {
                                width: 100,
                                height: 100,
                                className: "max-h-full -ml-4"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-grow mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarStepper, {
                            activeStep: steps.findIndex(function(s) {
                                return s === currentStep;
                            }),
                            steps: steps,
                            labelMapper: useLabelMapper(),
                            onChangeStep: function(_, step) {
                                dispatch(stepper/* stepper.setStep */.Sc.setStep(step));
                            },
                            disabledSteps: disabledSteps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                className: classnames_default()("overflow-y-auto bg-white h-[calc(100vh-80px)] ", props.className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container py-10 md:py-20 max-w-screen-sm min-h-full grid place-items-center sm:-mt-[80px]",
                    children: children
                })
            }))
        ]
    });
};
/* harmony default export */ var components_StepperLayout = (StepperLayout);


/***/ }),

/***/ 75961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13793);

function useAuthentication() {
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.authentication;
    });
}


/***/ }),

/***/ 87117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useChannelConfig; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13793);

var useChannelConfig = function() {
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.channelConfig;
    });
};


/***/ }),

/***/ 86609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useDefaultEntity; }
/* harmony export */ });
/* harmony import */ var _use_channel_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87117);

/**
 * The default entity configured for the channel
 */ var useDefaultEntity = function() {
    var channelConfig = (0,_use_channel_config__WEBPACK_IMPORTED_MODULE_0__/* .useChannelConfig */ .M)();
    return channelConfig.locations.find(function(param) {
        var EntityHierarchy = param.EntityHierarchy;
        return channelConfig.mappedLocationHierarchy === EntityHierarchy;
    });
};


/***/ }),

/***/ 7722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useInduction; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13793);

function useInduction() {
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.induction;
    });
}


/***/ }),

/***/ 43216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useStepper; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13793);

function useStepper() {
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.stepper;
    });
}


/***/ }),

/***/ 84055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useTextOverrides; }
/* harmony export */ });
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13793);

function useTextOverrides() {
    var ref;
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref1;
        return (ref = (ref1 = state.channelConfig.appVariantSettings) === null || ref1 === void 0 ? void 0 : ref1.textOverrides) !== null && ref !== void 0 ? ref : {};
    });
}


/***/ }),

/***/ 45583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50853);
// EXTERNAL MODULE: ./src/hooks/use-induction.ts
var use_induction = __webpack_require__(7722);
// EXTERNAL MODULE: ./src/slices/induction.ts
var slices_induction = __webpack_require__(66124);
// EXTERNAL MODULE: ./src/slices/stepper.ts
var stepper = __webpack_require__(76739);
// EXTERNAL MODULE: ./src/store/index.ts + 5 modules
var store = __webpack_require__(13793);
// EXTERNAL MODULE: ../../packages/kenai-core/src/hooks/use-toast.ts
var use_toast = __webpack_require__(65413);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(42713);
// EXTERNAL MODULE: ../../node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(41712);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(5012);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(67107);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(35510);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(15328);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(73217);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(3437);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(64237);
// EXTERNAL MODULE: ../../node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(157);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Backdrop/Backdrop.js + 2 modules
var Backdrop = __webpack_require__(90441);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(46619);
// EXTERNAL MODULE: ../../node_modules/material-ui-popup-state/index.js
var material_ui_popup_state = __webpack_require__(73423);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/induction/InductionProvider.tsx





var InductionContext = /*#__PURE__*/ (0,react.createContext)(null);
var initialInduction = {
    inductionVideoLink: "",
    version: "",
    inductionQuestions: []
};
var initialState = {
    open: false,
    loading: "idle",
    videoCompleted: false,
    videoSkipped: false,
    questionsCompleted: false,
    questionsSkipped: false
};
var saveParseState = function(state) {
    return function(fallback) {
        if (!state) {
            return fallback;
        }
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            inductionQuestions: state.inductionQuestions || []
        });
    };
};
var InductionProvider = function(props) {
    var ref = (0,react.useState)(saveParseState(props.initialInduction)(initialInduction)), induction = ref[0], setInduction = ref[1];
    var ref1 = (0,react.useState)((0,_object_spread/* default */.Z)({}, initialState, props.initialState)), state = ref1[0], setState = ref1[1];
    var setOpen = function(visible) {
        setState(function(curr) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), {
                open: visible
            });
        });
    };
    var setLoading = function(loading) {
        setState(function(curr) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), {
                loading: loading
            });
        });
    };
    var setCompleted = function(completed, type, data) {
        setState(function(curr) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), (0,_define_property/* default */.Z)({}, "".concat(type, "Completed"), completed));
        });
        if (completed) {
            setOpen(false);
            if (type === "video") {
                var ref;
                (ref = props.onCompletedVideo) === null || ref === void 0 ? void 0 : ref.call(props);
            } else {
                var ref1;
                (ref1 = props.onCompletedQuestions) === null || ref1 === void 0 ? void 0 : ref1.call(props, data !== null && data !== void 0 ? data : {});
            }
        }
    };
    var setSkipped = function(skipped, type) {
        setState(function(curr) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), (0,_define_property/* default */.Z)({}, "".concat(type, "Skipped"), skipped));
        });
        if (skipped) {
            if (type === "video") {
                var ref;
                (ref = props.onSkippedVideo) === null || ref === void 0 ? void 0 : ref.call(props);
            } else {
                var ref1;
                (ref1 = props.onSkippedQuestions) === null || ref1 === void 0 ? void 0 : ref1.call(props);
            }
        }
    };
    var handleNext = function() {
        var ref;
        (ref = props.onNext) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InductionContext.Provider, {
        value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, induction), {
            defaultValue: props.defaultValue,
            setInduction: setInduction,
            state: state,
            setOpen: setOpen,
            setLoading: setLoading,
            setCompleted: setCompleted,
            setSkipped: setSkipped,
            handleNext: handleNext
        }),
        children: props.children
    });
};
var InductionConsumer = InductionContext.Consumer;
var useInduction = function() {
    return (0,react.useContext)(InductionContext);
};

// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.module.js + 1 modules
var zod_module = __webpack_require__(85367);
// EXTERNAL MODULE: ../../packages/kenai-core/src/components/form/index.ts + 9 modules
var components_form = __webpack_require__(52324);
// EXTERNAL MODULE: ../../packages/kenai-core/src/hooks/use-media-query.ts
var use_media_query = __webpack_require__(91363);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Tooltip/Tooltip.js + 55 modules
var Tooltip = __webpack_require__(58719);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(50817);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/induction/InductionQuestions.tsx











var resolveQuestion = function(question, control, disabled) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormInput.Radio */.yt.Radio, {
        control: control,
        name: question.questionId,
        label: question.label,
        required: true,
        disabled: disabled,
        options: question.staticDropDownListItems.map(function(option) {
            return {
                value: option.dataKey,
                label: option.text
            };
        })
    }, question.questionId);
};
var useSchema = function() {
    var induction = useInduction();
    var inductionQuestions = induction.inductionQuestions;
    var fields = {};
    var gradedFields = {};
    if (inductionQuestions === null || inductionQuestions === void 0 ? void 0 : inductionQuestions[0]) {
        inductionQuestions.forEach(function(question) {
            var field = lib.z.string().nonempty({
                message: "The question is required"
            });
            fields[question.questionId] = field;
            // A question may mark SEVERAL answers correct - any one of them passes. A question
            // with none marked is unscored: any choice passes, so it gets no graded field at all.
            var correctKeys = question.staticDropDownListItems.filter(function(answer) {
                return Boolean(answer.correct);
            }).map(function(answer) {
                return answer.dataKey;
            });
            if (correctKeys.length > 0) {
                gradedFields[question.questionId] = field.refine(function(value) {
                    return correctKeys.includes(value);
                }, {
                    message: "Incorrect answer"
                });
            }
        });
    }
    return {
        filledSchema: lib.z.object(fields),
        gradedSchema: lib.z.object(gradedFields)
    };
};
function InductionQuestions() {
    var ref;
    var ref1 = useSchema(), filledSchema = ref1.filledSchema, gradedSchema = ref1.gradedSchema;
    var _ref = useInduction(), state = _ref.state, induction = (0,_object_without_properties/* default */.Z)(_ref, [
        "state"
    ]);
    var isOpen = state.open;
    // A questions-only induction has no video to complete first, so the gate is satisfied by
    // there being no video.
    var videoSatisfied = !induction.inductionVideoLink || state.videoCompleted;
    var questionsCompleted = state.questionsCompleted;
    var _inductionQuestions;
    var inductionQuestions = (_inductionQuestions = induction.inductionQuestions) !== null && _inductionQuestions !== void 0 ? _inductionQuestions : [];
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: (ref = induction.defaultValue) === null || ref === void 0 ? void 0 : ref.questions,
        resolver: (0,zod_module/* zodResolver */.F)(filledSchema)
    }), handleSubmit = ref2.handleSubmit, control = ref2.control;
    var fullScreen = (0,use_media_query/* useMediaQuery */.a)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var toast = (0,use_toast/* useToast */.p)();
    var handleOpen = function(visible) {
        induction.setOpen(visible);
    };
    var onSubmit = (0,react.useCallback)(function(data) {
        var result = gradedSchema.safeParse(data);
        if (result.success) {
            induction.setCompleted(true, "questions", result.data);
            toast("Induction questions completed", {
                variant: "success",
                autoHideDuration: 5000
            });
        } else {
            toast("You got one or more questions incorrect. Please retry.", {
                variant: "error",
                autoHideDuration: 5000
            });
        }
    }, [
        induction,
        gradedSchema,
        toast
    ]);
    var OpenQuestionButton = function(props) {
        var buttonText = props.completed ? "Questionnaire completed" : props.skipped ? "Questionnaire skipped, Start Now?" : "Start induction questionnaire";
        var button = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: props.videoCompleted ? "text" : "outlined",
            onClick: function() {
                return handleOpen(true);
            },
            startIcon: props.completed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {}) : null,
            disabled: !props.videoCompleted,
            children: buttonText
        });
        if (!props.videoCompleted) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                title: "You need to complete the induction video first",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: button
                })
            });
        }
        return button;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenQuestionButton, {
                completed: questionsCompleted,
                videoCompleted: videoSatisfied,
                skipped: state.questionsSkipped
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: isOpen,
                onClose: function() {
                    return handleOpen(false);
                },
                fullScreen: fullScreen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                            children: "Induction questions"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                            dividers: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-1 divide-y gap-2",
                                children: inductionQuestions.map(function(question) {
                                    return resolveQuestion(question, control, questionsCompleted);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function() {
                                        return handleOpen(false);
                                    },
                                    children: questionsCompleted ? "Close" : "Cancel"
                                }),
                                !questionsCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                    loading: state.loading === "pending",
                                    type: "submit",
                                    children: "Submit"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(47591);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(64979);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/lottie/Animation.tsx



var Animation = function(lottieOptions) {
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), lottie = ref1[0], setLottie = ref1[1];
    (0,react.useEffect)(function() {
        __webpack_require__.e(/* import() */ 642).then(__webpack_require__.t.bind(__webpack_require__, 12039, 23)).then(function(Lottie) {
            return setLottie(Lottie.default);
        });
    }, []);
    (0,react.useEffect)(function() {
        if (lottie && ref.current) {
            var animation = lottie.loadAnimation((0,_object_spread/* default */.Z)({
                container: ref.current
            }, lottieOptions));
            return function() {
                return animation.destroy();
            };
        }
    }, [
        lottie,
        lottieOptions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref
    });
};

;// CONCATENATED MODULE: ../../packages/kenai-core/src/lottie/DoneIndicator.tsx








var cachedAnimationData = null;
var getDataForColor = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(primaryColor) {
        var data, _tmp, values, _values, r, g, b, shapes, toUnitVector;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = cachedAnimationData;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 988).then(__webpack_require__.t.bind(__webpack_require__, 56988, 19))
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    data = _tmp;
                    cachedAnimationData = data;
                    values = (0,colorManipulator/* decomposeColor */.tB)(primaryColor).values;
                    _values = (0,_sliced_to_array/* default */.Z)(values, 3), r = _values[0], g = _values[1], b = _values[2];
                    shapes = [
                        {
                            i: 8,
                            j: 0,
                            k: 1,
                            a: 1
                        },
                        {
                            i: 9,
                            j: 0,
                            k: 1,
                            a: 1
                        },
                        {
                            i: 10,
                            j: 0,
                            k: 2,
                            a: 1
                        }
                    ];
                    toUnitVector = function(n) {
                        return Math.round(n / 255 * 1000) / 1000;
                    };
                    shapes.forEach(function(entry) {
                        data.layers[entry.i].shapes[entry.j].it[entry.k].c.k = [
                            toUnitVector(r),
                            toUnitVector(g),
                            toUnitVector(b),
                            entry.a, 
                        ];
                    });
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getDataForColor(primaryColor) {
        return _ref.apply(this, arguments);
    };
}();
var DoneIndicator = /*#__PURE__*/ (0,react.memo)(function MemoDoneIndicator() {
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,react.useState)(), animationData = ref[0], setAnimationData = ref[1];
    var ref1 = (0,react.useState)(false), shouldMount = ref1[0], setShouldMount = ref1[1];
    var primaryColor = theme.palette.primary.main;
    (0,react.useEffect)(function() {
        var handleSetAnimation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getDataForColor(primaryColor)
                            ];
                        case 1:
                            data = _state.sent();
                            setAnimationData(data);
                            setShouldMount(true);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSetAnimation() {
                return _ref.apply(this, arguments);
            };
        }();
        setShouldMount(false);
        handleSetAnimation();
    }, [
        primaryColor
    ]);
    var lottieOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData
    };
    if (!shouldMount || !animationData) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animation, (0,_object_spread/* default */.Z)({}, lottieOptions));
});
/* harmony default export */ var lottie_DoneIndicator = (DoneIndicator);

// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Fullscreen.js
var Fullscreen = __webpack_require__(25744);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/Pause.js
var Pause = __webpack_require__(480);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/PlayArrow.js
var PlayArrow = __webpack_require__(31913);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/VolumeDown.js
var VolumeDown = __webpack_require__(83382);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/VolumeOff.js
var VolumeOff = __webpack_require__(42842);
// EXTERNAL MODULE: ../../node_modules/@mui/icons-material/VolumeUp.js
var VolumeUp = __webpack_require__(19481);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Slider/Slider.js + 8 modules
var Slider = __webpack_require__(48618);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(40196);
// EXTERNAL MODULE: ../../node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98485);
// EXTERNAL MODULE: ../../node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(46105);
// EXTERNAL MODULE: ../../node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(55566);
// EXTERNAL MODULE: ../../node_modules/@sentry/react/esm/errorboundary.js + 3 modules
var errorboundary = __webpack_require__(32399);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/induction/InductionVideo.tsx















var getVolumeIcon = function(volume) {
    if (volume === 0) {
        return VolumeOff/* default */.Z;
    } else if (volume < 0.5) {
        return VolumeDown/* default */.Z;
    } else {
        return VolumeUp/* default */.Z;
    }
};
var toReadableTime = function toReadableTime(value) {
    var sec_num = parseInt(value, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;
    if (hours < 10) {
        hours = "0" + hours;
    }
    if (hours <= 0) {
        hours = undefined;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return [
        hours,
        minutes,
        seconds
    ].filter(Boolean).join(":");
};
var launchIntoFullscreen = function launchIntoFullscreen(element) {
    if ( true && "requestFullscreen" in element) {
        element.requestFullscreen();
    }
};
var exitFullscreen = function exitFullscreen() {
    if ( true && "exitFullscreen" in document) {
        document.exitFullscreen();
    }
};
var VolumeSlider = function(param) {
    var _volume = param.volume, volume = _volume === void 0 ? 0 : _volume, onSetVolume = param.onSetVolume, onInteraction = param.onInteraction;
    var ref = (0,react.useState)(false), hovered = ref[0], setHovered = ref[1];
    var ref1 = (0,react.useState)(false), capturing = ref1[0], setCapturing = ref1[1];
    var ref2 = (0,react.useState)(false), waitingLeave = ref2[0], setWaitingLeave = ref2[1];
    var previousVolumeRef = (0,react.useRef)(1);
    var toggleMute = function() {
        if (volume > 0) {
            // Mute: save current volume and set to 0
            previousVolumeRef.current = volume;
            onSetVolume(0);
        } else {
            // Unmute: restore previous volume (or default to 1 if never set)
            onSetVolume(previousVolumeRef.current || 1);
        }
        onInteraction === null || onInteraction === void 0 ? void 0 : onInteraction();
    };
    var handleIconMouseEnter = function(e) {
        e.stopPropagation();
        setWaitingLeave(false);
        setHovered(true);
    };
    var handleChange = function(value) {
        setCapturing(true);
        var newVolume = value / 100;
        onSetVolume(newVolume);
        // Update previous volume if not muted
        if (newVolume > 0) {
            previousVolumeRef.current = newVolume;
        }
        onInteraction === null || onInteraction === void 0 ? void 0 : onInteraction();
    };
    var handleChangeCommitted = (0,react.useCallback)(function() {
        setCapturing(false);
        if (waitingLeave) {
            setHovered(false);
            setWaitingLeave(false);
        }
    }, [
        waitingLeave
    ]);
    var handleLeave = (0,react.useCallback)(function() {
        if (!capturing) {
            setHovered(false);
        } else {
            setWaitingLeave(true);
        }
    }, [
        capturing
    ]);
    var Icon = getVolumeIcon(volume);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onMouseEnter: function() {
            setWaitingLeave(false);
            setHovered(true);
        },
        onMouseLeave: handleLeave,
        className: "flex space-x-4 items-center w-[100px] h-[48px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                onClick: toggleMute,
                onMouseEnter: handleIconMouseEnter,
                style: {
                    cursor: "pointer"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                className: classnames_default()(!hovered ? "hidden" : ""),
                "aria-label": "Volume",
                value: volume * 100,
                onChange: function(e, value) {
                    return handleChange(value);
                },
                onChangeCommitted: handleChangeCommitted
            })
        ]
    });
};
var videoUtils = {
    getProgress: function(video) {
        if (!video) {
            return 0;
        }
        var progress = video.currentTime / video.duration * 100;
        return progress;
    },
    getBufferValue: function(video) {
        if (!video) {
            return 0;
        }
        try {
            var ref, ref1;
            var buffered = (ref = video.buffered) === null || ref === void 0 ? void 0 : (ref1 = ref.end) === null || ref1 === void 0 ? void 0 : ref1.call(ref, 0);
            var duration = video.duration;
            var bufferedProgress = buffered / duration * 100;
            return bufferedProgress;
        } catch (error) {
            return 0;
        }
    }
};
var InductionVideo = function() {
    var ref, ref1;
    var videoRef = (0,react.useRef)();
    var containerRef = (0,react.useRef)(null);
    var theme = (0,useTheme/* default */.Z)();
    var ref2 = (0,react.useState)(1), volume = ref2[0], setVolume = ref2[1];
    var toast = (0,use_toast/* useToast */.p)();
    var ref3 = (0,react.useState)(0), videoProgress = ref3[0], setProgress = ref3[1];
    var ref4 = (0,react.useState)(0), videoBuffer = ref4[0], setVideoBuffer = ref4[1];
    var ref5 = (0,react.useState)(""), videoDuration = ref5[0], setDuration = ref5[1];
    var ref6 = (0,react.useState)("paused"), videoStatus = ref6[0], setStatus = ref6[1];
    var ref7 = (0,react.useState)(false), isLoading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,react.useState)(false), fullScreen = ref8[0], setFullScreen = ref8[1];
    var ref9 = (0,react.useState)(null), videoAspectRatio = ref9[0], setVideoAspectRatio = ref9[1];
    var induction = useInduction();
    var completed = induction.state.videoCompleted;
    var inductionVideoLink = induction.inductionVideoLink;
    var ref10 = (0,react.useState)(inductionVideoLink), videoLink = ref10[0], setVideoLink = ref10[1];
    var ref11 = (0,react.useState)(false), panelVisible = ref11[0], setPanelVisible = ref11[1];
    var autoHideTimerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setVideoLink(inductionVideoLink);
        setVideoAspectRatio(null); // Reset aspect ratio when video changes
    }, [
        inductionVideoLink
    ]);
    var isPlaying = videoStatus === "playing";
    var isComplete = completed && !isPlaying;
    (0,react.useEffect)(function() {
        if (videoStatus === "playing") {
            setPanelVisible(false);
            // Clear any existing timer
            if (autoHideTimerRef.current) {
                clearTimeout(autoHideTimerRef.current);
                autoHideTimerRef.current = null;
            }
        }
    // Don't auto-show toolbar when paused - only show on user interaction
    }, [
        videoStatus
    ]);
    (0,react.useEffect)(function() {
        if (videoRef.current) {
            videoRef.current.volume = volume;
        }
    }, [
        volume
    ]);
    (0,react.useEffect)(function() {
        if (videoProgress === 100) {
            setStatus("ended");
            if (!completed) {
                induction.setCompleted(true, "video");
            }
        }
    }, [
        videoProgress
    ]);
    (0,react.useEffect)(function() {
        var video = videoRef.current;
        var progressEvent = function() {
            if (!video) return;
            setProgress(videoUtils.getProgress(video));
            setDuration("".concat(toReadableTime(video.currentTime), " / ").concat(toReadableTime(video.duration)));
        };
        var bufferEvent = function() {
            if (!video) return;
            setVideoBuffer(videoUtils.getBufferValue(video));
        };
        if ( true && video) {
            video.addEventListener("timeupdate", progressEvent);
            video.addEventListener("progress", bufferEvent);
        }
        return function() {
            if ( true && video) {
                video.removeEventListener("timeupdate", progressEvent);
                video.addEventListener("progress", bufferEvent);
            }
            // Cleanup auto-hide timer on unmount
            if (autoHideTimerRef.current) {
                clearTimeout(autoHideTimerRef.current);
            }
        };
    }, []);
    var handleVideoLoaded = function(event) {
        var video = event.target;
        if (isNaN(video.duration)) {
            return; // duration is NotaNumber at Beginning.
        }
        setDuration("".concat(toReadableTime(video.currentTime), " / ").concat(toReadableTime(video.duration)));
        // Set aspect ratio to prevent layout shift
        if (video.videoWidth && video.videoHeight && !videoAspectRatio) {
            setVideoAspectRatio("".concat(video.videoWidth, " / ").concat(video.videoHeight));
        }
    };
    var showToolbar = (0,react.useCallback)(function() {
        setPanelVisible(true);
        // Clear any existing timer
        if (autoHideTimerRef.current) {
            clearTimeout(autoHideTimerRef.current);
            autoHideTimerRef.current = null;
        }
        // Auto-hide after 3 seconds if playing
        if (isPlaying) {
            autoHideTimerRef.current = setTimeout(function() {
                setPanelVisible(false);
                autoHideTimerRef.current = null;
            }, 3000);
        }
    }, [
        isPlaying
    ]);
    var handlePlayPause = function() {
        var video = videoRef.current;
        if (!video) return;
        if (videoStatus !== "playing") {
            video.play();
            setStatus("playing");
        } else {
            video.pause();
            setStatus("paused");
        }
        // Show toolbar when interacting with play/pause
        showToolbar();
    };
    var handleToggleFullscreen = function() {
        if (containerRef.current) {
            if (!fullScreen) {
                setFullScreen(true);
                launchIntoFullscreen(containerRef.current);
            } else {
                setFullScreen(false);
                exitFullscreen();
            }
        }
        // Show toolbar when interacting with fullscreen
        showToolbar();
    };
    var handleContainerClick = function(e) {
        // Don't toggle if clicking on controls
        var target = e.target;
        if (target.closest(".controls") || target.closest("button") || target.closest('[role="slider"]')) {
            return;
        }
        showToolbar();
    };
    var ActionIcon = isPlaying ? Pause/* default */.Z : PlayArrow/* default */.Z;
    var ActionLabel = !isPlaying ? "Play" : "Pause";
    var backgroundColor = (ref = theme.palette.grey) === null || ref === void 0 ? void 0 : ref["900"];
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        ref: containerRef,
        sx: {
            backgroundColor: backgroundColor
        },
        className: classnames_default()("relative overflow-hidden", !fullScreen && "rounded-[5px]"),
        onClick: handleContainerClick,
        onMouseLeave: function() {
            if (isPlaying && !fullScreen) {
            // Only hide on mouse leave if playing and not in fullscreen
            // The auto-hide timer will handle hiding
            }
        },
        onTouchStart: showToolbar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "An error has occurred while loading the video"
                }),
                showDialog: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    component: "video",
                    playsInline: true,
                    ref: videoRef,
                    width: "100%",
                    controls: false,
                    onClick: handlePlayPause,
                    onLoadedData: handleVideoLoaded,
                    onLoadedMetadata: function(e) {
                        var video = e.target;
                        if (video.videoWidth && video.videoHeight && !videoAspectRatio) {
                            setVideoAspectRatio("".concat(video.videoWidth, " / ").concat(video.videoHeight));
                        }
                    },
                    onCanPlayThrough: function() {
                        setVideoBuffer(100);
                    },
                    sx: {
                        height: fullScreen ? "100vh" : undefined,
                        aspectRatio: fullScreen ? "unset" : videoAspectRatio || "16 / 9",
                        objectFit: "contain",
                        display: "block",
                        maxHeight: fullScreen ? "100vh" : undefined,
                        width: "100%"
                    },
                    className: classnames_default()("mb-[-6px]", {
                        "rounded-[5px]": !fullScreen,
                        "pb-[48px]": fullScreen
                    }),
                    onWaiting: function() {
                        setLoading(true); // Buffer States
                    },
                    onPlaying: function() {
                        setLoading(false); // Buffer States
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: videoLink,
                            type: "video/mp4",
                            onError: function() {
                                toast("Could not load video", {
                                    variant: "error",
                                    autoHideDuration: 3000
                                });
                            }
                        }),
                        "Your browser doesn't support videos."
                    ]
                })
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("w-full h-full absolute top-0 bottom-0 left-0 right-0 flex place-items-center justify-center pointer-events-none"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
            }),
            !isLoading && !isPlaying && !isComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: "absolute top-[50%] left-[50%] cursor-pointer z-20",
                sx: {
                    transform: "translate(-50%, -50%)"
                },
                onClick: handlePlayPause,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "aria-label": "Play",
                    sx: {
                        width: 64,
                        height: 64,
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            color: function(theme) {
                                return theme.palette.primary.main;
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayArrow/* default */.Z, {
                        sx: {
                            fontSize: 40
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: "absolute bottom-0 left-0 right-0 h-[60px] z-10",
                onMouseEnter: showToolbar,
                sx: {
                    pointerEvents: panelVisible || fullScreen ? "auto" : "auto"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    color: (ref1 = theme.palette.grey) === null || ref1 === void 0 ? void 0 : ref1["100"]
                },
                className: classnames_default()("controls h-[48px] bottom-0 left-0 right-0 absolute transition-all ease-in-out duration-500", panelVisible || fullScreen ? "bottom-0" : "bottom-[-48px]"),
                onMouseEnter: showToolbar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-gradient-to-t from-slate-900/60 absolute h-[calc(100%+48px)] w-full bottom-0 pointer-events-none"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
                                variant: "buffer",
                                value: videoProgress,
                                valueBuffer: videoBuffer,
                                sx: (_obj = {}, (0,_define_property/* default */.Z)(_obj, ".MuiLinearProgress-dashedColorPrimary", {
                                    backgroundColor: "rgba(255,255,255,.2)",
                                    animation: "none",
                                    backgroundImage: "none"
                                }), (0,_define_property/* default */.Z)(_obj, ".MuiLinearProgress-bar2Buffer", {
                                    backgroundColor: "rgba(255,255,255,.4)"
                                }), _obj)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                className: "flex justify-between items-center h-[44px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center z-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                "aria-label": ActionLabel,
                                                onClick: handlePlayPause,
                                                sx: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "&:hover", {
                                                    color: function(theme) {
                                                        return theme.palette.primary.main;
                                                    }
                                                }), (0,_define_property/* default */.Z)(_obj1, "color", "white"), _obj1),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VolumeSlider, {
                                                volume: volume,
                                                onSetVolume: setVolume,
                                                onInteraction: showToolbar
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center space-x-2 z-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "caption",
                                                children: videoDuration
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                "aria-label": "Toggle Fullscreen",
                                                onClick: handleToggleFullscreen,
                                                sx: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, "&:hover", {
                                                    color: function(theme) {
                                                        return theme.palette.primary.main;
                                                    }
                                                }), (0,_define_property/* default */.Z)(_obj2, "color", "white"), _obj2),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fullscreen/* default */.Z, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                className: classnames_default()("absolute top-[50%] left-[50%]", {
                    hidden: isPlaying || !isComplete
                }),
                sx: {
                    transform: "translate(-50%, -50%)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_DoneIndicator, {})
            })
        ]
    });
};
/* harmony default export */ var induction_InductionVideo = (InductionVideo);

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/induction/induction.tsx















var Induction = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InductionProvider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InductionContent, (0,_object_spread/* default */.Z)({}, props))
    }));
};
function InductionContent(props) {
    var _ref = useInduction(), state = _ref.state, induction = (0,_object_without_properties/* default */.Z)(_ref, [
        "state"
    ]);
    var videoCompleted = state.videoCompleted;
    var hasQuestions = (induction.inductionQuestions || []).length > 0;
    // A questions-only induction has no video to complete: the video gate is satisfied by
    // there being no video, otherwise the step can never be passed.
    var hasVideo = Boolean(induction.inductionVideoLink);
    var videoSatisfied = !hasVideo || videoCompleted;
    var title = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            height: 30
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            className: "flex items-center space-x-2",
            children: videoCompleted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                        color: "primary"
                    }),
                    " ",
                    "Induction video completed"
                ]
            }) : "Watch the whole induction video to proceed."
        })
    });
    var showSkip = props.allowSkip && (!videoSatisfied || hasQuestions && !state.questionsCompleted);
    var showContinue = !showSkip || videoSatisfied && (!hasQuestions || state.questionsCompleted);
    var continueDisabled = !videoSatisfied || hasQuestions && !state.questionsCompleted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-6 w-full",
        children: [
            hasVideo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                        sx: {
                            mb: 1
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(induction_InductionVideo, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-x-2 flex justify-end",
                children: [
                    showSkip && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipButton, {
                        variant: hasQuestions ? "outlined" : "contained"
                    }),
                    hasQuestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(InductionQuestions, {}),
                    showContinue && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                        variant: "contained",
                        onClick: !continueDisabled ? induction.handleNext : undefined,
                        disabled: continueDisabled,
                        loading: state.loading === "pending" || props.loading,
                        children: props.nextButtonText || "Next"
                    })
                ]
            })
        ]
    });
}
var SkipButton = function(param) {
    var variant = param.variant;
    var _ref = useInduction(), state = _ref.state, induction = (0,_object_without_properties/* default */.Z)(_ref, [
        "state"
    ]);
    var toast = (0,use_toast/* useToast */.p)();
    var hasQuestions = (induction.inductionQuestions || []).length > 0;
    // The same satisfied-gate the step's buttons use: a questions-only induction has no video
    // to skip, so Skip must fall through to the questions rather than recording a skip for a
    // section that does not exist.
    var hasVideo = Boolean(induction.inductionVideoLink);
    var videoSatisfied = !hasVideo || state.videoCompleted;
    var skipsVideo = hasVideo && !state.videoCompleted;
    var handleSkip = (0,react.useCallback)(function() {
        if (skipsVideo) {
            // skip the video
            toast("Induction video skipped", {
                variant: "info",
                autoHideDuration: 3000
            });
            induction.setSkipped(true, "video");
        } else {
            // skip the questions
            toast("Induction questions skipped", {
                variant: "info",
                autoHideDuration: 3000
            });
            induction.setSkipped(true, "questions");
        }
        induction.handleNext();
    }, [
        skipsVideo,
        toast,
        induction
    ]);
    var showVideoRelatedContent = !videoSatisfied || !hasQuestions;
    var type = showVideoRelatedContent && hasVideo ? "video" : "questions";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(material_ui_popup_state/* default */.ZP, {
        variant: "popover",
        popupId: "skip-induction-popover",
        children: function(popupState) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        variant: variant
                    }, (0,material_ui_popup_state/* bindTrigger */.vW)(popupState)), {
                        children: "Skip"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,material_ui_popup_state/* bindPopover */.ZW)(popupState)), {
                        anchorOrigin: {
                            vertical: -5,
                            horizontal: "right"
                        },
                        transformOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        "aria-labelledby": "skip-induction-title",
                        "aria-describedby": "skip-induction-description",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                                id: "skip-induction-title",
                                children: "Are you sure you want to skip the induction ".concat(type, "?")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                                id: "skip-induction-description",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                                    variant: "caption",
                                    children: "* Come back and complete it here later, or on site before your meeting"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: function() {
                                            if (!showVideoRelatedContent) {
                                                induction.setOpen(true);
                                            }
                                            popupState.close();
                                        },
                                        children: showVideoRelatedContent ? "No, watch now" : "No, complete now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: handleSkip,
                                        children: "Yes, skip"
                                    })
                                ]
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop/* default */.Z, {
                        sx: {
                            zIndex: function(theme) {
                                return theme.zIndex.drawer + 1;
                            }
                        },
                        open: popupState.isOpen,
                        onClick: function() {
                            return popupState.close();
                        }
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./src/components/StepperLayout.tsx + 1 modules
var StepperLayout = __webpack_require__(64045);
;// CONCATENATED MODULE: ./src/components/induction/induction.tsx










var Layout = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperLayout/* default */.Z, {
        className: "induction-layout",
        children: props.children
    });
};
function InductionView() {
    var induction = (0,use_induction/* useInduction */.O)();
    var dispatch = (0,store/* useDispatch */.I0)();
    var toast = (0,use_toast/* useToast */.p)();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, submitAction, isFulfilled, isSuccess, isSubmissionError, isGenericError, genericError, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,slices_induction/* submitInduction */.i5)())
                        ];
                    case 1:
                        submitAction = _state.sent();
                        isFulfilled = slices_induction/* submitInduction.fulfilled.match */.i5.fulfilled.match(submitAction);
                        isSuccess = isFulfilled && submitAction.payload.key === "OPERATION_PROCESSED";
                        isSubmissionError = isFulfilled && submitAction.payload.key === "OPERATION_FAILED";
                        isGenericError = isFulfilled && submitAction.payload.key === "GENERIC_ERROR";
                        if (isSuccess || isSubmissionError) {
                            // We handle these messages with validationError or static success message on the summary screen
                            dispatch(stepper/* stepper.nextStep */.Sc.nextStep());
                            return [
                                2
                            ];
                        }
                        genericError = "We ran into an unknown error while submitting your request, please contact support if this persists.";
                        toast(isGenericError ? (ref1 = (ref = submitAction.payload.error) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : genericError : genericError, {
                            variant: "error",
                            autoHideDuration: 5000
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Induction, {
            initialInduction: induction.inductionData,
            nextButtonText: "Submit",
            onNext: handleSubmit,
            loading: induction.loading === "pending"
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/use-step.ts
var use_step = __webpack_require__(43216);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/result/result.tsx



var adornment = function(value) {
    if (typeof value === "string" || typeof value === "number") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "primary",
            className: "text-4xl font-extrabold sm:text-5xl",
            children: value
        });
    }
    return value;
};
var title = function(value) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "h2",
        className: "text-2xl font-bold tracking-tight sm:text-3xl",
        children: value
    });
};
var message = function(value) {
    var isString = typeof value === "string";
    if (isString) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: "mt-1 text-base text-gray-500",
            dangerouslySetInnerHTML: {
                __html: value
            }
        });
    }
    return value;
};
function Result(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "sm:flex",
        children: [
            props.adornment && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:border-r sm:border-gray-200 sm:pr-6 sm:mr-6",
                children: adornment(props.adornment)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: props.center ? "text-center" : "",
                children: [
                    title(props.title),
                    message(props.message)
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../packages/kenai-utils/dist/index.js
var dist = __webpack_require__(75671);
;// CONCATENATED MODULE: ./src/pages/index.tsx







var IdentificationSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 488).then(__webpack_require__.bind(__webpack_require__, 52488));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52488)
            ];
        }
    }
});
var Agreement = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 181).then(__webpack_require__.bind(__webpack_require__, 58181));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58181)
            ];
        }
    }
});
var Authentication = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 190).then(__webpack_require__.bind(__webpack_require__, 81190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81190)
            ];
        }
    }
});
var Summary = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 792).then(__webpack_require__.bind(__webpack_require__, 74792));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74792)
            ];
        }
    }
});
var Page = function(props) {
    var stepper = (0,use_step/* useStepper */.t)();
    if (stepper.currentStep === "agreement") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Agreement, {});
    }
    if (stepper.currentStep === "authentication") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication, {});
    }
    if (stepper.currentStep === "induction") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InductionView, {});
    }
    if (stepper.currentStep === "summary") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {});
    }
    throw new Error("App should never get here");
};
Page.getLayout = function(page) {
    var props = page.props;
    if (false) {}
    if ("errorMessage" in props && props.errorMessage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Result, {
            adornment: 500,
            title: "Oops",
            message: props.errorMessage
        });
    }
    if ("uisDualModeEnabled" in props && props.uisDualModeEnabled === true) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IdentificationSelector, {
            identifierButtonText: props.uisIdentifiersButtonText,
            ssoButtonText: props.uisSsoButtonText
        });
    }
    var title = "Kenai";
    if ("channelConfig" in props) {
        var ref, ref1;
        title = ((ref = props.channelConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.locations) === null || ref1 === void 0 ? void 0 : ref1[0].companyName) || "Kenai";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "Induction - ",
                        title
                    ]
                })
            }),
            page
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (Page);


/***/ }),

/***/ 52324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yt": function() { return /* binding */ FormInput; }
});

// UNUSED EXPORTS: FormInputCheckbox, FormInputDropdown, FormInputNumber, FormInputRadio, FormInputSlider, FormInputText

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55988);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(16510);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/kenai-core/src/components/input/OutlinedInput.ts
var OutlinedInput = __webpack_require__(49980);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/input/Text.tsx








var Text = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var name = _param.name, label = _param.label, required = _param.required, defaultValue = _param.defaultValue, onEnter = _param.onEnter, focusNextOnEnter = _param.focusNextOnEnter, helperText = _param.helperText, error = _param.error, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "required",
        "defaultValue",
        "onEnter",
        "focusNextOnEnter",
        "helperText",
        "error"
    ]);
    var fullWidth = "fullWidth" in inputProps ? inputProps.fullWidth : true;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
        variant: "standard",
        error: !!error,
        disabled: inputProps.readOnly,
        fullWidth: fullWidth,
        hidden: inputProps.hidden,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* OutlinedInputLabel */.k, {
                shrink: true,
                htmlFor: "".concat(name, "-input"),
                required: required,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps), {
                ref: ref
            }), name && {
                id: "".concat(name, "-input")
            }), {
                onKeyDown: function(event) {
                    var _$ref;
                    if (event.key === "Enter" && !event.shiftKey) {
                        event.preventDefault(); // Avoids new line because of multiline
                        if (focusNextOnEnter) {
                            var form = event.target.form;
                            if (form) {
                                var index = (0,_to_consumable_array/* default */.Z)(form).indexOf(event.target);
                                var nextInput = form.elements[index + 3];
                                if ("focus" in nextInput) {
                                    form.elements[index + 3].focus();
                                }
                            }
                        }
                    }
                    if (event.key === "Enter") {
                        onEnter === null || onEnter === void 0 ? void 0 : onEnter(event);
                    }
                    (_$ref = inputProps.onKeyDown) === null || _$ref === void 0 ? void 0 : _$ref.call(inputProps, event);
                }
            })),
            helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                sx: {
                    ml: 0
                },
                color: "textSecondary",
                children: helperText
            })
        ]
    });
});
Text.displayName = "Text";

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputText.tsx






var FormInputText = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, required = _param.required, defaultValue = _param.defaultValue, onEnter = _param.onEnter, focusNextOnEnter = _param.focusNextOnEnter, helperText = _param.helperText, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "required",
        "defaultValue",
        "onEnter",
        "focusNextOnEnter",
        "helperText"
    ]);
    var fullWidth = "fullWidth" in inputProps ? inputProps.fullWidth : true;
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var help = error ? error.message : helperText;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps, field), {
                required: required,
                helperText: help,
                id: "".concat(name, "-input"),
                value: field.value || "",
                label: label,
                fullWidth: fullWidth,
                error: !!error
            }));
        }
    });
};

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputNumber.tsx







/** Ensure that the output is a number value */ var transform = {
    input: function(value) {
        return isNaN(value) || value === 0 ? "" : value.toString();
    },
    output: function(e) {
        var output = parseInt(e.target.value, 10);
        return isNaN(output) ? 0 : output;
    }
};
var FormInputNumber = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, placeholder = _param.placeholder, readOnly = _param.readOnly, required = _param.required, defaultValue = _param.defaultValue, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "placeholder",
        "readOnly",
        "required",
        "defaultValue"
    ]);
    var fullWidth = "fullWidth" in inputProps ? inputProps.fullWidth : true;
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var helperText = error ? error.message : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                variant: "standard",
                error: !!error,
                disabled: readOnly,
                fullWidth: fullWidth,
                hidden: inputProps.hidden,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* OutlinedInputLabel */.k, {
                        shrink: true,
                        htmlFor: "".concat(name, "-input"),
                        required: required,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps, field), {
                        type: "number",
                        inputMode: "numeric",
                        onChange: function(e) {
                            return field.onChange(transform.output(e));
                        },
                        id: "".concat(name, "-input"),
                        placeholder: placeholder,
                        readOnly: readOnly,
                        value: transform.input(field.value)
                    })),
                    helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        sx: {
                            ml: 0
                        },
                        children: helperText
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ../../packages/kenai-core/src/components/input/Select.tsx
var Select = __webpack_require__(30892);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputDropdown.tsx






var FormInputDropdown = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, options = _param.options, placeholder = _param.placeholder, multiple = _param.multiple, readOnly = _param.readOnly, required = _param.required, tag = _param.tag, defaultValue = _param.defaultValue, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "options",
        "placeholder",
        "multiple",
        "readOnly",
        "required",
        "tag",
        "defaultValue"
    ]);
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var isGroupedSelection = options.some(function(option) {
        var ref;
        return "itemGroupings" in option ? Boolean((ref = option.itemGroupings) === null || ref === void 0 ? void 0 : ref[0]) : false;
    });
    var getSelectionWithGrouping = (0,react.useCallback)(function(fieldValue, selectedValue) {
        if (!isGroupedSelection) {
            debugger;
            return fieldValue;
        }
        var nextValue = handleSelectWithGroupings(fieldValue, options, selectedValue).nextValue;
        return nextValue;
    }, [
        isGroupedSelection,
        options
    ]);
    var parsedDefaultValue = defaultValue || multiple ? [] : "";
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    var serializeValue = function(value) {
        if (value) {
            if (multiple && !Array.isArray(value)) {
                return [
                    value
                ];
            }
            return value;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: parsedDefaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var helperText = error ? error.message : inputProps.helperText;
            var _value;
            var fieldValue = serializeValue((_value = field.value) !== null && _value !== void 0 ? _value : defaultValue);
            var handleSingleSelect = function(selectionValue) {
                field.onChange(selectionValue);
            };
            var handleMultiSelect = function(selectedList, child) {
                var selectionValue = child.props.value; // this is from the MenuItem node in Select component
                var selection = getSelectionWithGrouping(selectedList, selectionValue);
                return field.onChange(selection);
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                fullWidth: true,
                name: name,
                label: label,
                open: visible,
                error: !!error,
                disabled: readOnly,
                helperText: helperText,
                displayEmpty: !!placeholder,
                placeholder: placeholder,
                multiple: multiple,
                readOnly: readOnly,
                options: options,
                value: fieldValue,
                onOpen: function() {
                    return setVisible(true);
                },
                onClose: function() {
                    return setVisible(false);
                },
                onChange: !multiple ? handleSingleSelect : handleMultiSelect
            });
        }
    });
};
function handleSelectWithGroupings(fieldValue, options, selectedValue) {
    var hasGroupedToSingleItem = false;
    var nextValue = (0,_to_consumable_array/* default */.Z)(fieldValue);
    var newItemDef = options.find(function(item) {
        return item.value === selectedValue;
    });
    if (nextValue.length > 1) {
        // part 3.a handle multiple parts check
        if (newItemDef) {
            nextValue = nextValue.filter(function(newPart) {
                if (selectedValue === newPart) return true;
                var existingItemDef = options.find(function(item) {
                    return item.value === newPart;
                });
                if (!existingItemDef) return false;
                if (newItemDef.itemGroupings) {
                    //new item has groupings - check whether existing item overlaps
                    if (!existingItemDef.itemGroupings) return false;
                    var hasOverlap = false;
                    newItemDef.itemGroupings.forEach(function(itemGrouping) {
                        if ((existingItemDef.itemGroupings || []).indexOf(itemGrouping) > -1) {
                            hasOverlap = true;
                        }
                    });
                    return hasOverlap;
                } else if (existingItemDef.itemGroupings && existingItemDef.itemGroupings.length > 0) {
                    //existing item has a grouping and new item does not - this implies existing item should be removed as there is no overlap
                    return false;
                } else {
                    return true; //no groupings
                }
            });
        }
    }
    if (nextValue.length === 1) {
        // part 3.b handle single parts check
        var hasAtLeastOneAdditionalInGroup = false;
        options.forEach(function(existingItemDef) {
            if (existingItemDef.value !== (newItemDef === null || newItemDef === void 0 ? void 0 : newItemDef.value)) {
                var ref;
                if (newItemDef === null || newItemDef === void 0 ? void 0 : (ref = newItemDef.itemGroupings) === null || ref === void 0 ? void 0 : ref.length) {
                    newItemDef.itemGroupings.forEach(function(itemGrouping) {
                        if (existingItemDef.itemGroupings && existingItemDef.itemGroupings.indexOf(itemGrouping) > -1) {
                            hasAtLeastOneAdditionalInGroup = true;
                        }
                    });
                } else {
                    var ref1;
                    if (!((ref1 = existingItemDef.itemGroupings) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                        hasAtLeastOneAdditionalInGroup = true;
                    }
                }
            }
        });
        if (!hasAtLeastOneAdditionalInGroup) {
            hasGroupedToSingleItem = true;
        }
    }
    return {
        nextValue: nextValue,
        hasGroupedToSingleItem: hasGroupedToSingleItem
    };
}

// EXTERNAL MODULE: ../../node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(27419);
// EXTERNAL MODULE: ../../node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(79511);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(79728);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/constants.ts
var constants = {
    variant: "outlined"
};

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputCheckbox.tsx









var FormInputCheckbox = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, placeholder = _param.placeholder, options = _param.options, readOnly = _param.readOnly, required = _param.required, defaultValue = _param.defaultValue, multiple = _param.multiple, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "placeholder",
        "options",
        "readOnly",
        "required",
        "defaultValue",
        "multiple"
    ]);
    var getNewSelection = (0,react.useCallback)(function(event, selected) {
        var checked = event.target.checked;
        var option = event.target.name;
        if (multiple) {
            var selectedOptions = selected || [];
            var hasOption = selectedOptions.includes(option);
            if (!checked && hasOption) {
                var ref;
                return (ref = selectedOptions.filter) === null || ref === void 0 ? void 0 : ref.call(selectedOptions, function(item) {
                    return item !== option;
                });
            } else if (checked && !hasOption) {
                return (0,_to_consumable_array/* default */.Z)(selectedOptions).concat([
                    option
                ]);
            }
        } else {
            if (checked) {
                return option;
            } else {
                return "";
            }
        }
    }, [
        multiple
    ]);
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var helperText = error ? error.message : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                component: "fieldset",
                variant: constants.variant,
                error: !!error,
                disabled: readOnly,
                required: required,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        component: "legend",
                        sx: {
                            ml: 0
                        },
                        children: label
                    }) // this uses the same styling as the FormLabel
                    ,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        children: options.map(function(option) {
                            var selected = field.value || [];
                            var checked = selected.includes(option.value);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                label: option.label,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps), {
                                    name: option.value,
                                    checked: checked,
                                    onChange: function(event) {
                                        return field.onChange(getNewSelection(event, selected));
                                    },
                                    readOnly: readOnly
                                }))
                            }, option.value);
                        })
                    }),
                    helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        sx: {
                            ml: 0
                        },
                        children: helperText
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Slider/Slider.js + 8 modules
var Slider = __webpack_require__(48618);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputSlider.tsx








var FormInputSlider = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, placeholder = _param.placeholder, readOnly = _param.readOnly, required = _param.required, min = _param.min, max = _param.max, step = _param.step, unit = _param.unit, defaultValue = _param.defaultValue, _valueLabelSize = _param.valueLabelSize, valueLabelSize = _valueLabelSize === void 0 ? 32 : _valueLabelSize, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "placeholder",
        "readOnly",
        "required",
        "min",
        "max",
        "step",
        "unit",
        "defaultValue",
        "valueLabelSize"
    ]);
    var marks = getMarks(min, max, unit);
    var hasMarks = Boolean(marks === null || marks === void 0 ? void 0 : marks[0]);
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    if (min) {
        rules.min = min;
    }
    if (max) {
        rules.max = max;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var helperText = error ? error.message : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                variant: "standard",
                error: !!error,
                disabled: readOnly,
                fullWidth: true,
                hidden: inputProps.hidden,
                sx: hasMarks ? {
                    pb: 1
                } : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* OutlinedInputLabel */.k, {
                        shrink: true,
                        id: "".concat(name, "-slider-label"),
                        required: required,
                        className: inputProps.valueLabelDisplay === "on" ? "pb-[40px]" : undefined,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps, field), {
                        value: field.value || min || 0,
                        "aria-labelledby": "".concat(name, "-slider-label"),
                        step: step,
                        min: min,
                        max: max,
                        getAriaValueText: function(value) {
                            return getAriaValueText(value, unit);
                        },
                        valueLabelDisplay: inputProps.valueLabelDisplay || "auto",
                        marks: marks,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({}, "label + &", {
                            mt: 1
                        }), hasMarks && {
                            width: "90%",
                            mx: "auto"
                        }), {
                            "& .MuiSlider-valueLabel": {
                                lineHeight: 1.2,
                                fontSize: 12,
                                background: "unset",
                                padding: 0,
                                width: valueLabelSize,
                                height: valueLabelSize,
                                borderRadius: "50% 50% 50% 0",
                                backgroundColor: function(theme) {
                                    return theme.palette.primary.dark;
                                },
                                transformOrigin: "bottom left",
                                transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
                                "&:before": {
                                    display: "none"
                                },
                                "&.MuiSlider-valueLabelOpen": {
                                    transform: "translate(50%, -100%) rotate(-45deg) scale(1)"
                                },
                                "& > *": {
                                    transform: "rotate(45deg)"
                                }
                            }
                        })
                    })),
                    helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        sx: {
                            ml: 0
                        },
                        children: helperText
                    })
                ]
            });
        }
    });
};
function getAriaValueText(value, unit) {
    return unit ? "".concat(value).concat(unit) : value.toString();
}
var getMarks = function(min, max, unit) {
    if (!min || !max) {
        return undefined;
    }
    var createMark = function(value) {
        return {
            value: value,
            label: getAriaValueText(value, unit)
        };
    };
    var start = createMark(min);
    var midpoint = createMark((min + max) / 2);
    var end = createMark(max);
    return [
        start,
        midpoint,
        end
    ];
};

// EXTERNAL MODULE: ../../node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(91060);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(9672);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(5012);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormGroupContainer.tsx



var FormGroupContainer = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "label + &, legend + &", {
        marginTop: theme.spacing(1)
    }), (0,_define_property/* default */.Z)(_obj, "border", "1px solid"), (0,_define_property/* default */.Z)(_obj, "borderColor", theme.palette.divider), (0,_define_property/* default */.Z)(_obj, "borderRadius", theme.shape.borderRadius), (0,_define_property/* default */.Z)(_obj, "padding", theme.spacing(1)), (0,_define_property/* default */.Z)(_obj, ".Mui-error &", {
        borderColor: theme.palette.error.main
    }), _obj;
});

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/FormInputRadio.tsx








var FormInputRadio = function(_param) {
    var name = _param.name, control = _param.control, label = _param.label, placeholder = _param.placeholder, options = _param.options, readOnly = _param.readOnly, required = _param.required, _direction = _param.direction, direction = _direction === void 0 ? "row" : _direction, defaultValue = _param.defaultValue, inputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "control",
        "label",
        "placeholder",
        "options",
        "readOnly",
        "required",
        "direction",
        "defaultValue"
    ]);
    var rules = {};
    if (required) {
        rules.required = "Required";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
        name: name,
        control: control,
        defaultValue: defaultValue,
        rules: rules,
        render: function(param) {
            var field = param.field, error = param.fieldState.error;
            var helperText = error ? error.message : null;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                component: "fieldset",
                variant: constants.variant,
                error: !!error,
                disabled: readOnly,
                required: required,
                sx: {
                    width: "100%"
                },
                className: !!error ? "Mui-error" : "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormHelperText/* default */.Z, {
                        id: "".concat(name, "-radio-group-label"),
                        component: "legend",
                        sx: {
                            ml: 0
                        },
                        children: [
                            label,
                            " ",
                            required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "aria-hidden": true,
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroupContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            "aria-labelledby": "".concat(name, "-radio-group-label"),
                            row: direction === "row"
                        }, field), {
                            value: field.value || "",
                            children: options.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    value: option.value,
                                    label: option.label,
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputProps), {
                                        name: option.value,
                                        readOnly: readOnly
                                    }))
                                }, option.value);
                            })
                        }))
                    }),
                    helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                        sx: {
                            ml: 0
                        },
                        children: helperText
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ../../packages/kenai-core/src/components/form/index.ts







var FormInput = {
    Text: FormInputText,
    Number: FormInputNumber,
    Dropdown: FormInputDropdown,
    Checkbox: FormInputCheckbox,
    Slider: FormInputSlider,
    Radio: FormInputRadio
};


/***/ }),

/***/ 49980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ OutlinedInputLabel; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11276);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98232);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67393);


var OutlinedInput = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        "label + &": {
            marginTop: theme.spacing(1)
        }
    };
});
var OutlinedInputLabel = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return {
        "&.MuiInputLabel-shrink": {
            whiteSpace: "inherit",
            position: "relative",
            textAlign: "justify",
            width: "100%",
            transform: "none",
            fontSize: "calc(1em * 0.75)"
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (OutlinedInput);


/***/ }),

/***/ 30892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5012);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24058);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79728);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55988);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90636);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68466);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46499);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67107);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15328);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16510);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _OutlinedInput__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49980);







function renderValue(options, placeholder, tag) {
    // MUI calls this to render the closed field's content, so it is a formatter the
    // Select invokes, not a component React mounts.
    // eslint-disable-next-line react/display-name
    return function(value) {
        if (value === undefined || value === "") {
            return placeholder;
        }
        var isMultipleSelect = Array.isArray(value);
        var selectedOptions = [];
        if (isMultipleSelect) {
            selectedOptions = options.filter(function(option) {
                return value.includes(option.value);
            });
        } else {
            selectedOptions = options.filter(function(option) {
                return value === option.value;
            });
        }
        if (tag) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5
                },
                children: selectedOptions.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        label: option.label
                    }, option.value);
                })
            });
        }
        return selectedOptions.map(function(option) {
            return option.label;
        }).join(", ");
    };
}
function createOption() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _multiple = ref.multiple, multiple = _multiple === void 0 ? false : _multiple, _checked = ref.checked, checked = _checked === void 0 ? false : _checked, _disabled = ref.disabled, disabled = _disabled === void 0 ? false : _disabled;
    // A per-option renderer mapped over the list, not a component in its own right.
    // eslint-disable-next-line react/display-name
    return function(option) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            value: option.value,
            disabled: Boolean(disabled),
            children: [
                multiple && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    checked: checked
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        whiteSpace: "pre-wrap"
                    },
                    children: option.label
                })
            ]
        }, option.value);
    };
}
var Select = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(baseProps, ref) {
    var name = baseProps.name, label = baseProps.label, options = baseProps.options, _placeholder = baseProps.placeholder, placeholder = _placeholder === void 0 ? "Select an option" : _placeholder, readOnly = baseProps.readOnly, error = baseProps.error, required = baseProps.required, tag = baseProps.tag, helperText = baseProps.helperText, disabled = baseProps.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(baseProps, [
        "name",
        "label",
        "options",
        "placeholder",
        "readOnly",
        "error",
        "required",
        "tag",
        "helperText",
        "disabled"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.open || false), open = _$ref[0], setOpen = _$ref[1];
    var _value;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((_value = props.value) !== null && _value !== void 0 ? _value : props.multiple) ? [] : ""), value = _$ref1[0], setValue = _$ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fallbackValue = props.multiple ? [] : "";
        setValue(props.value || fallbackValue);
    }, [
        props.value,
        props.multiple
    ]);
    var onOpen = function(event) {
        setOpen(true);
        if ("onOpen" in props && props.onOpen) {
            props.onOpen(event);
        }
    };
    var onClose = function(event) {
        setOpen(false);
        if ("onClose" in props && props.onClose) {
            props.onClose(event);
        }
    };
    var onChange = function(value, child) {
        setValue(value);
        if ("onChange" in props && props.onChange) {
            props.onChange(value, child);
        }
    };
    var isMultiSelect = props.multiple;
    var showPlaceholder = !value || isMultiSelect && value.length === 0;
    var _$ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        fullWidth: true,
        error: !!error,
        disabled: readOnly,
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutlinedInput__WEBPACK_IMPORTED_MODULE_8__/* .OutlinedInputLabel */ .k, {
                shrink: true,
                id: "".concat(name, "-label"),
                required: required,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                ref: ref
            }, props), {
                disabled: Boolean(disabled),
                value: value,
                open: open,
                onOpen: onOpen,
                onClose: onClose,
                onChange: function(event, child) {
                    return onChange(event.target.value, child);
                },
                displayEmpty: !!placeholder,
                renderValue: renderValue(options, placeholder, tag),
                input: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OutlinedInput__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                className: showPlaceholder ? "placeholder" : "",
                "aria-labelledby": "".concat(name, "-label"),
                fullWidth: true,
                sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, props.sx), {
                    "& .MuiInputBase-inputMultiline": {
                        whiteSpace: "inherit!important"
                    },
                    "&.placeholder .MuiInputBase-input": {
                        color: function(theme) {
                            var _$ref;
                            return (_$ref = theme.palette.neutral) === null || _$ref === void 0 ? void 0 : _$ref["400"];
                        }
                    }
                }),
                children: [
                    createOption({
                        disabled: true
                    })({
                        value: "",
                        label: placeholder
                    }),
                    options.map(function(option) {
                        var checked = value === option.value;
                        if (Array.isArray(value)) {
                            var _$ref;
                            checked = (_$ref = value.includes) === null || _$ref === void 0 ? void 0 : _$ref.call(value, option.value);
                        }
                        return createOption({
                            multiple: props.multiple,
                            checked: checked
                        })(option);
                    }),
                    isMultiSelect && [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}, "divider"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    variant: "caption",
                                    children: [
                                        (_$ref2 = value === null || value === void 0 ? void 0 : value.length) !== null && _$ref2 !== void 0 ? _$ref2 : 0,
                                        " of ",
                                        options.length
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-grow justify-end space-x-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: "contained",
                                        onClick: function() {
                                            return setOpen(false);
                                        },
                                        children: "Done"
                                    })
                                })
                            ]
                        }, "footer"), 
                    ]
                ]
            })),
            helperText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                sx: {
                    ml: 0
                },
                children: helperText
            })
        ]
    });
});
Select.displayName = "Select";


/***/ }),

/***/ 59811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ S3Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* eslint-disable @next/next/no-img-element */ 


var S3Image = function(_param) {
    var src = _param.src, alt = _param.alt, _className = _param.className, className = _className === void 0 ? "" : _className, _width = _param.width, width = _width === void 0 ? 50 : _width, _height = _param.height, height = _height === void 0 ? 50 : _height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        className: className,
        width: width,
        height: height
    }, props));
};


/***/ }),

/***/ 91363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73303);

function useMediaQuery(queryInput, options) {
    return (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(queryInput, options);
}


/***/ }),

/***/ 65413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19657);

function useToast() {
    var ref = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)(), enqueueSnackbar = ref.enqueueSnackbar, closeSnackbar = ref.closeSnackbar;
    var toast = enqueueSnackbar;
    toast.closeToast = closeSnackbar;
    return toast;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [597,151,774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);